import { PageHeader } from "../components/Common";
import { Mission } from "./SettingsPage";

export default function MissionPage() {
  return (
    <div data-testid="mission-page">
      <PageHeader overline="Organisation DNA" title="Mission & Values" desc="Who we are, where we're heading and what we stand for." />
      <div className="rounded-md border bg-card"><Mission admin={false} /></div>
    </div>
  );
}
